import { render, staticRenderFns } from "./giftinfo_jdyx.vue?vue&type=template&id=49fd35e3&scoped=true"
import script from "./giftinfo_jdyx.vue?vue&type=script&lang=js"
export * from "./giftinfo_jdyx.vue?vue&type=script&lang=js"
import style0 from "./giftinfo_jdyx.vue?vue&type=style&index=0&id=49fd35e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd35e3",
  null
  
)

export default component.exports